export default function getColumns(order) {
  const {
    column1Printed,
    column2Printed,
    column3Printed,
    column4Printed,
    column1Highlighted,
    column2Highlighted,
    column3Highlighted,
    column4Highlighted,
    column1Title,
    column2Title,
    column3Title,
    column4Title,
  } = order

  return [
    { id: 1, printed: column1Printed,  highlighted: column1Highlighted, title: column1Title },
    { id: 2, printed: column2Printed,  highlighted: column2Highlighted, title: column2Title },
    { id: 3, printed: column3Printed,  highlighted: column3Highlighted, title: column3Title },
    { id: 4, printed: column4Printed,  highlighted: column4Highlighted, title: column4Title },
  ]

}